// src/hooks/useStockNotifications.js
import { useState, useEffect } from 'react';
import api from '../utils/api';
import { useSocket } from '../components/context/SocketProvider';
import { useAuth } from '../components/context/AuthContext';

export const useStockNotifications = () => {
    const [pendingStockCount, setPendingStockCount] = useState(0);
    const socket = useSocket();
    const { user, loading } = useAuth();

    useEffect(() => {
        // ⭐ FIX: wait for the real session, not just the cached profile.
        // AuthContext hydrates `user` IMMEDIATELY from a cached localStorage
        // profile on page load, before the real __session cookie exists —
        // the login round trip is still in flight. Firing this fetch against
        // that cached-but-not-yet-authenticated state got a 403 every time
        // (harmless — it retries once the real session settles and `user`
        // updates again — but noisy). `loading` only goes false once auth
        // has genuinely resolved.
        if (loading) return;
        // Only fetch if the user is logged in and is an admin or manager
        if (!user || (user.role !== 'admin' && user.role !== 'manager')) return;

        const fetchPendingRequests = async () => {
            try {
                const res = await api.get('/stock/requests');
                const pending = res.data.filter(req => req.status === 'Pending').length;
                setPendingStockCount(pending);
            } catch (error) {
                console.error('Failed to fetch pending stock requests for sidebar:', error);
            }
        };

        fetchPendingRequests();

        // Listen for real-time updates
        if (socket) {
            const handleUpdate = () => {
                fetchPendingRequests();
            };
            
            // Listen for brand new requests
            socket.on('new-stock-request', handleUpdate);
            
            // ⭐ NEW: Listen for when a request is approved or rejected
            socket.on('stock-request-updated', handleUpdate); 
            
            return () => {
                socket.off('new-stock-request', handleUpdate);
                socket.off('stock-request-updated', handleUpdate);
            };
        }
    }, [socket, user, loading]);

    return { pendingStockCount };
};